export default __webpack_public_path__ + "static/media/aboutImg03.fe7d7e9a.jpg";